import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './Components/App';
import AppContextProviders from './Context';
import '../src/shared/Component/Survey/SurveyRankingCustomWidget';

ReactDOM.render(
  <BrowserRouter>
    <AppContextProviders>
      <App />
    </AppContextProviders>
  </BrowserRouter>,
  document.getElementById('root')
);

window.React = React;
